import { SVGProps } from "react";

export default function H1Icon(props: SVGProps<SVGSVGElement>) {
  const { width = 12, height = 13, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.125C1.7071 2.125 1.875 2.2929 1.875 2.5V10.5C1.875 10.7071 1.7071 10.875 1.5 10.875C1.2929 10.875 1.125 10.7071 1.125 10.5V2.5C1.125 2.2929 1.2929 2.125 1.5 2.125Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 2.125C6.4571 2.125 6.625 2.2929 6.625 2.5V10.5C6.625 10.7071 6.4571 10.875 6.25 10.875C6.0429 10.875 5.875 10.7071 5.875 10.5V2.5C5.875 2.2929 6.0429 2.125 6.25 2.125Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.125 6.5C1.125 6.2929 1.2929 6.125 1.5 6.125H6.25C6.4571 6.125 6.625 6.2929 6.625 6.5C6.625 6.7071 6.4571 6.875 6.25 6.875H1.5C1.2929 6.875 1.125 6.7071 1.125 6.5Z"
        fill="#545454"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.88794 4.90985C10.03 4.96693 10.1232 5.10469 10.1232 5.25783V10.5037C10.1232 10.7108 9.95529 10.8787 9.74819 10.8787C9.54109 10.8787 9.37319 10.7108 9.37319 10.5037V6.19136L8.82549 6.76311C8.68219 6.91266 8.44484 6.91776 8.29529 6.77446C8.14569 6.63121 8.14064 6.39381 8.28389 6.24426L9.47739 4.99841C9.58334 4.88783 9.74584 4.85277 9.88794 4.90985Z"
        fill="#545454"
      />
    </svg>
  );
}
